import type { DocumentStatus, SimpleRole } from "@prismicio/editor-fields"

type Permission = Record<SimpleRole, boolean>

const Owner: Permission = {
  SuperUser: true,
  Owner: true,
  Administrator: false,
  Manager: false,
  Writer: false,
  Readonly: false,
}

const Administrator: Permission = {
  SuperUser: true,
  Owner: true,
  Administrator: true,
  Manager: false,
  Writer: false,
  Readonly: false,
}

const Manager: Permission = {
  SuperUser: true,
  Owner: true,
  Administrator: true,
  Manager: true,
  Writer: false,
  Readonly: false,
}

const Writer: Permission = {
  SuperUser: true,
  Owner: true,
  Administrator: true,
  Manager: true,
  Writer: true,
  Readonly: false,
}

export const accessSettingsPermission = Administrator
export const manageEnvironmentPermission = Administrator
export const syncEnvPermission = Administrator
export const updatePlanPermission = Owner
export const deleteRepositoryPermission = Owner
export const manageTeamSpacePermission = Administrator
export const createDocumentPermission = Writer
export const editDocumentPermission = Writer
export const publishDocumentPermission = Manager
export const addDocumentToScheduledReleasePermission = Manager
export const addDocumentToUnscheduledReleasePermission = Writer
export const unpublishDocumentPermission = Manager
export const archiveUnclassifiedDocumentPermission = Writer
export const archivePublishedDocumentPermission = Manager
export const archiveReleaseDocumentPermission = Manager
export const deleteDocumentPermission = Writer

export const canRoleArchiveDocument = (
  role: SimpleRole,
  status: DocumentStatus,
) => {
  if (status === "unclassified")
    return archiveUnclassifiedDocumentPermission[role]
  if (status === "published") return archivePublishedDocumentPermission[role]
  if (status === "release") return archiveReleaseDocumentPermission[role]
  return false
}
